
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Normothermiaequipment() {



  const cardData =
  {
    keyword: 'Normothermia Equipment in Hyderabad',
    heading: 'Pharmacle Health Care Private Limited: Normothermia Equipment in Hyderabad',
    headingDescription: 'Pharmacle Health Care Private Limited provides advanced Normothermia Equipment in Hyderabad, ensuring precise temperature management for patients during surgeries and critical care. Our Wallabies Warm Care systems help maintain normothermia, reducing the risk of hypothermia-related complications and improving patient recovery. Trusted by hospitals and healthcare professionals, our normothermia equipment is designed for safety, efficiency, and ease of use. Choose Pharmacle Health Care for the best temperature management solutions in Hyderabad to enhance patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',

   "topPlaces": [
  {
    "title": "Pharmacle Advanced Normothermia Equipment in Hyderabad",
    "description": "Pharmacle Health Care Private Limited provides advanced normothermia equipment in Hyderabad, designed to maintain stable body temperature during surgeries and critical care treatments. Our systems ensure safer procedures and improved patient outcomes."
  },
  {
    "title": "Pharmacle Forced Air Warming System – Reliable Thermal Care",
    "description": "Our forced air warming system delivers consistent and controlled heat distribution, helping hospitals in Hyderabad prevent perioperative hypothermia in surgical, ICU, and emergency care environments."
  },
  {
    "title": "Pharmacle Surgical Normothermia System for Operating Rooms",
    "description": "Specially engineered for surgical theaters, Pharmacle’s surgical normothermia system reduces temperature-related complications, ensuring normothermia and improving recovery rates for patients in Hyderabad hospitals."
  },
  {
    "title": "Portable Normothermia Device by Pharmacle",
    "description": "Compact and efficient, our portable normothermia devices are ideal for ambulances, emergency wards, and field medical units in Hyderabad. They provide rapid warming for patients in critical conditions."
  },
  {
    "title": "Neonatal Normothermia System – Gentle Warming for Newborns",
    "description": "Pharmacle Health Care Private Limited supplies neonatal normothermia systems in Hyderabad, providing safe and gentle warming for premature and low-birth-weight infants in NICUs and maternity wards."
  },
  {
    "title": "ICU Normothermia Equipment by Pharmacle",
    "description": "Our ICU-ready normothermia equipment is designed for critically ill patients, delivering precise temperature regulation in Hyderabad intensive care units to support faster recovery and improved safety."
  },
  {
    "title": "Pharmacle Preoperative & Postoperative Warming Systems",
    "description": "Hospitals in Hyderabad rely on Pharmacle’s pre- and postoperative warming systems to stabilize body temperature before anesthesia and after surgery, reducing complications and ensuring patient comfort."
  },
  {
    "title": "Veterinary Normothermia Systems from Pharmacle",
    "description": "Pharmacle Health Care Private Limited also supports veterinary clinics in Hyderabad with normothermia systems that regulate safe body temperature for pets and animals during surgery and treatment."
  },
  {
    "title": "Temperature-Controlled Air Warmer – Pharmacle Technology",
    "description": "Pharmacle’s advanced temperature-controlled air warmers feature customizable heat settings for precise use in Hyderabad operating rooms and recovery wards, ensuring optimal thermal care."
  },
  {
    "title": "Pharmacle Emergency Medical Warming Systems in Hyderabad",
    "description": "Critical for trauma care, our emergency medical warming systems are widely used in Hyderabad hospitals to prevent hypothermia and stabilize patient temperature during life-saving treatments."
  }
],


"services": [
    {
        "name": "Normothermia Equipment Hyderabad",
        "description": "Pharmacle Health Care Private Limited offers normothermia equipment in Hyderabad, designed to maintain a stable and safe body temperature for patients during medical procedures. These devices are essential for preventing temperature-related complications and ensuring patient safety."
    },
    {
        "name": "Patient Thermoregulation Hyderabad",
        "description": "Our patient thermoregulation solutions in Hyderabad are designed to regulate and monitor patient body temperature during surgeries, critical care, and recovery, helping prevent hypothermia and promoting optimal outcomes."
    },
    {
        "name": "Warming Systems Hyderabad",
        "description": "We offer advanced warming systems in Hyderabad, designed to maintain a stable and comfortable body temperature for patients during medical treatments. Our systems ensure that patients remain safe and warm, especially in critical care settings."
    },
    {
        "name": "Medical Equipment for Temperature Control Hyderabad",
        "description": "Pharmacle Health Care provides medical equipment for temperature control in Hyderabad, including devices for patient warming, thermoregulation, and hypothermia prevention, ensuring optimal care in hospitals and surgical environments."
    },
    {
        "name": "Normothermia Devices Hyderabad",
        "description": "Our normothermia devices in Hyderabad are designed to prevent hypothermia and maintain normal body temperature for patients during medical procedures. These devices ensure the patient’s comfort and safety throughout the treatment."
    },
    {
        "name": "Hyderabad Temperature Regulation for Patients",
        "description": "Pharmacle Health Care provides temperature regulation solutions for patients in Hyderabad, ensuring that the patient’s body temperature remains within the optimal range during surgeries and medical procedures, reducing the risk of complications."
    },
    {
        "name": "Hyderabad Hypothermia Prevention",
        "description": "We offer hypothermia prevention solutions in Hyderabad, which include patient warming systems and thermoregulation devices designed to maintain a safe body temperature for patients, ensuring that they are protected from the adverse effects of hypothermia during medical treatments."
    }
],
"tableData": [
    ["- Normothermia Equipment Hyderabad", "- Patient Thermoregulation Hyderabad"],
    ["- Warming Systems Hyderabad", "- Medical Equipment for Temperature Control Hyderabad"],
    ["- Normothermia Devices Hyderabad", "- Hyderabad Temperature Regulation for Patients"],
    ["- Hyderabad Hypothermia Prevention"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced normothermia equipment in Hyderabad, designed to maintain optimal body temperature during medical procedures. Our technology ensures precise temperature control to prevent hypothermia, improving patient safety in hospitals and clinics across the city."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a wide range of normothermia equipment in Hyderabad, including forced air warming devices and blankets. Our solutions are designed to maintain body temperature during surgeries, critical care, and other medical treatments, ensuring that your patients remain comfortable and safe."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our normothermia equipment is manufactured to the highest quality standards, ensuring long-lasting performance and durability. Tested and maintained regularly, our systems offer optimal reliability for continuous use in medical environments across Hyderabad."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our normothermia equipment provides controlled, gentle warmth to prevent temperature-related complications during surgeries and medical procedures, ensuring patients in Hyderabad are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our normothermia solutions in Hyderabad are adaptable to various healthcare settings, including hospitals, clinics, and emergency rooms. We collaborate closely with healthcare providers to ensure our equipment meets their specific needs and improves overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care's normothermia equipment is designed for easy integration with existing medical systems in Hyderabad. Our products can be quickly implemented, ensuring that healthcare professionals can maintain continuous medical procedures without disruption."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We offer expert consultation in Hyderabad to help healthcare facilities choose the most suitable normothermia equipment. Our team also provides ongoing support and maintenance to ensure your equipment operates efficiently and delivers the best possible care."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of everything we do. Our normothermia equipment is designed to prevent temperature-related issues during critical medical procedures, ensuring that every patient in Hyderabad receives the highest standard of care."
    }
]






  }


  const faqData = [
    { question: "What is Normothermia Equipment?", answer: "Normothermia Equipment is designed to maintain a patient's body temperature within the normal range during medical procedures to prevent hypothermia and improve recovery outcomes." },
    { question: "How does Normothermia Equipment work?", answer: "Normothermia Equipment works by providing controlled temperature management, using forced air warming systems or other technologies to regulate the patient's body temperature during surgeries or treatments." },
    { question: "Is Normothermia Equipment available in Hyderabad?", answer: "Yes, Pharmacle Health Care Private Limited offers Normothermia Equipment in Hyderabad, ensuring healthcare facilities have access to reliable temperature management solutions for patients." },
    { question: "What are the benefits of using Normothermia Equipment?", answer: "The primary benefits include preventing hypothermia, improving patient comfort, reducing complications like surgical site infections, and speeding up recovery times." },
    { question: "How long does Normothermia Equipment maintain a patient's body temperature?", answer: "Normothermia Equipment can maintain a patient's temperature for the duration of the medical procedure, adjusting as needed to ensure stable and consistent warmth." },
    { question: "Is Normothermia Equipment easy to use?", answer: "Yes, it is designed to be user-friendly, with easy-to-adjust settings and intuitive controls, making it simple for healthcare professionals to use in various clinical settings." },
    { question: "Can Normothermia Equipment be used in all types of surgeries?", answer: "Yes, it can be used in a wide range of surgeries and medical procedures, especially those where temperature regulation is essential for patient safety." },
    { question: "Is Normothermia Equipment safe for all patients?", answer: "Yes, the equipment is safe for most patients. However, it should be used according to medical guidelines and monitored closely to ensure optimal patient comfort and safety." },
    { question: "How can I purchase Normothermia Equipment in Hyderabad?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will assist you in purchasing and delivering the Normothermia Equipment to your facility in Hyderabad." },
    { question: "Does Pharmacle Health Care offer support for Normothermia Equipment?", answer: "Yes, we provide full support for the Normothermia Equipment, including installation, staff training, and ongoing maintenance to ensure the system operates efficiently." }
  ];
  
  const testimonialsData = [
    {
      text: 'We have been using Normothermia Equipment from Pharmacle Health Care in our hospital in Hyderabad, and it has greatly improved our ability to maintain optimal body temperature in our patients during surgeries.',
      name: 'Dr. Suresh Reddy',
    },
    {
      text: 'Pharmacle Health Care’s Normothermia Equipment has been a valuable addition to our clinic in Hyderabad. It is easy to use, reliable, and ensures that our patients stay warm and comfortable during their procedures.',
      name: 'Dr. Lakshmi Sharma',
    }
  ];
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Normothermia Equipment in Hyderabad",
    "description": "Discover advanced Normothermia Equipment in Hyderabad for effective patient temperature regulation and hypothermia prevention. Our medical devices ensure optimal thermoregulation during surgeries and medical treatments.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.9",
      "ratingCount": "1150"
    }
  };
  

  


  return (
    <div>
  <Helmet>
    <title>Normothermia Equipment in Hyderabad | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Discover advanced Normothermia Equipment in Hyderabad for patient temperature regulation and hypothermia prevention. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Normothermia Equipment Hyderabad, Patient Thermoregulation Hyderabad, Warming Systems Hyderabad, Medical Equipment for Temperature Control Hyderabad, Normothermia Devices Hyderabad, Hyderabad Temperature Regulation for Patients, Hyderabad Hypothermia Prevention"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/6.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Normothermiaequipment;